import OptionDetailList from '../collections/optionDetailList';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionGroup = Backbone.Model.extend( {

    optionList: null,

    defaults: {
        'name': '',
        'options': []
    },

    initialize: function () {
        // track state of optionDetailList for easy access to selected option for validation
        this.optionList = new OptionDetailList( this.getOptionList() );

        this.listenTo( this.collection, 'clear:selected', this.clearSelected );
        this.listenTo( this.optionList, 'selected unselected', function () {
            this.trigger( 'filter:options' );
        } );

        // broadcast to parent views when an item in optionList has changed, used for setting next:target
        this.listenTo( this.optionList, 'invalidated', function () {
            app.mediator.trigger( 'update:route', app.appController.getCurrentSelection() );
            this.trigger( 'option:invalidated' );
        } );
    },

    hasSelection: function () {
        return !!this.optionList.current();
    },

    getOptionList: function () {
        var optionIds = this.get( 'options' );

        return _.filter( app.product.get( 'optionDetails' ), function ( item ) {
            return optionIds.indexOf( item.id ) > -1;
        } );
    },

    getOptionIds: function () {
        return this.optionList.map( function ( option ) {
            return option.get( 'id' );
        } );
    },

    clearSelected: function () {
        this.optionList.trigger( 'clear:selected' );
    }

} );

export default OptionGroup;
